import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M10.125 5.625a.75.75 0 1 1 0 1.5h-6.25a.5.5 0 0 0-.5.5v12.5a.5.5 0 0 0 .5.5h12.5a.5.5 0 0 0 .5-.5v-6.25a.75.75 0 1 1 1.5 0v6.25a2 2 0 0 1-2 2h-12.5a2 2 0 0 1-2-2v-12.5a2 2 0 0 1 2-2zm11.231-2.982a2.625 2.625 0 0 1 0 3.712l-7.955 7.955a.75.75 0 0 1-.424.212l-3.093.443a.75.75 0 0 1-.849-.848l.442-3.095a.75.75 0 0 1 .212-.424l7.955-7.955a2.625 2.625 0 0 1 3.712 0zM17.29 5.118l-6.364 6.364-.265 1.856 1.856-.265 6.364-6.364-1.591-1.59zm1.414-1.414l-.354.353 1.591 1.591.355-.353a1.125 1.125 0 1 0-1.592-1.591z' />
  </svg>
);
